import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import Img from 'gatsby-image';

import device from '../utils/device';

const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
`;

const Heading = styled.h2`
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;

  font-size: 1.24rem;
  padding: 3rem 1.6rem;

  @media ${device.desktop} {
    font-size: 2.5rem;
    padding: 5rem 0;
  }
`;

const FbContainer = styled.div`
  background: #e8ecef;

  margin: 0 1.6rem;
  padding: 1.6rem;

  @media ${device.desktop} {
    margin: 0 10vw;
    display: flex;
    padding: 4.2rem 2.6rem 0 2.6rem;
  }
`;

const MContainer = styled(FbContainer)`
  background: ${({ theme }) => theme.colors.white};
  padding: 1.6rem 0;

  @media ${device.desktop} {
    padding: 4.2rem 2.6rem 0 2.6rem;
  }
`;

const FbRow = styled.div`
  @media ${device.desktop} {
    width: 50%;
    padding: 0 3.5rem;
  }
`;

const QuoteImg = styled(Img)`
  margin-bottom: 1.6rem;

  @media ${device.desktop} {
    margin-bottom: 5rem;
  }
`;

const Quotes = () => {
  const images = useStaticQuery(query);

  return (
    <Container>
      <Heading>What previous reset participants have said...</Heading>

      <FbContainer>
        <FbRow>
          <QuoteImg fluid={images.q1.childImageSharp.fluid} />
          <QuoteImg fluid={images.q2.childImageSharp.fluid} />
        </FbRow>
        <FbRow>
          <QuoteImg fluid={images.q3.childImageSharp.fluid} />
          <QuoteImg fluid={images.q4.childImageSharp.fluid} />
        </FbRow>
      </FbContainer>

      <MContainer>
        <FbRow>
          <QuoteImg fluid={images.m1.childImageSharp.fluid} />
          <QuoteImg fluid={images.m2.childImageSharp.fluid} />
          <QuoteImg fluid={images.m3.childImageSharp.fluid} />
        </FbRow>
        <FbRow>
          <QuoteImg fluid={images.m4.childImageSharp.fluid} />
          <QuoteImg fluid={images.m5.childImageSharp.fluid} />
          <QuoteImg fluid={images.m6.childImageSharp.fluid} />
        </FbRow>
      </MContainer>
    </Container>
  );
};

const query = graphql`
  query {
    q1: file(relativePath: { eq: "fb-quote-0.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    q2: file(relativePath: { eq: "fb-quote-3.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    q3: file(relativePath: { eq: "fb-quote-1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    q4: file(relativePath: { eq: "fb-quote-2.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    m1: file(relativePath: { eq: "g-quote-1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    m2: file(relativePath: { eq: "g-quote-2.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    m3: file(relativePath: { eq: "g-quote-3.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    m4: file(relativePath: { eq: "g-quote-4.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    m5: file(relativePath: { eq: "g-quote-5.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    m6: file(relativePath: { eq: "g-quote-6.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

export default Quotes;
